import { SideCut } from '../side-cut';
import { Point } from '../utils/point';

export class ConfigurationSideCut {
  id?: string;
  startPoint?: Point;
  endPoint?: Point;
  length: number;

  sideCutId: number;
  sideCut: SideCut;

  constructor(startPoint: Point, endPoint: Point, sideCut: SideCut, length: number = 0) {
    this.startPoint = startPoint;
    this.endPoint = endPoint;
    if (length > 0) {
      this.length = length;
    } else {
      this.calculateLength();
    }
    if (sideCut !== null) {
      this.sideCut = sideCut;
      this.sideCutId = sideCut.id;
    }
  }

  private calculateLength() {
    let length = 0;

    const x = (this.endPoint.x - this.startPoint.x) ** 2;
    const y = (this.endPoint.y - this.startPoint.y) ** 2;
    length = Math.sqrt(x + y);

    this.length = Math.round(Math.abs(length));
  }
}
